export default __webpack_public_path__ + "images/f1aef63a4112db0c11c17b726f569639.svg";